module.exports = __webpack_public_path__ + "static/media/mio-background.2cb6e88e.jpg";